import { form2 } from '@pulseops/common'
import { pipe } from 'fp-ts/lib/function'
import i18next from 'i18next'
import * as t from 'io-ts'
import moment from 'moment'

export namespace APImportFileForm {
  const FileInfo = t.type({
    fileName: t.string,
    fileExtension: t.string,
    size: t.number,
    base64: t.string,
    uploadedDate: form2.date.required,
    file: form2.file.required
  })
  type APImportFileBrandData = {
    readonly MS150004: unique symbol
    readonly MS990067: unique symbol
    readonly MS990083: unique symbol
  }
  export type FileInfo = t.TypeOf<typeof FileInfo>
  type APImportFileBrand = t.Branded<FileInfo[], APImportFileBrandData>
  export const APImportFileFormType = t.type({
    attachmentFiles: pipe(
      t.array(FileInfo),
      form2.refine(
        (l): l is APImportFileBrand => l && l.length > 0,
        () => i18next.t('message:MS150004'),
        'MS150004'
      ),
      form2.refine(
        (file): file is APImportFileBrand => {
          const isValidFileFormat = file.length > 0
            && file[0].fileName.split('_').length > 2
            && isRightFormatWithDDMMYYYY(file[0].fileName.split('_')[0])
            && isRightFormatWithX(file[0].fileName.split('_')[2])
          return isValidFileFormat
        },
        () => i18next.t('message:MS990067'),
        'MS990067'
      ),
      form2.refine(
        (file): file is APImportFileBrand => {
          return file.length > 0 && file[0].fileName.split('_').length > 0 && isEqualWithCurrentDate(file[0].fileName.split('_')[0])
        },
        () => i18next.t('message:MS990083'),
        'MS990083'
      )
    )
  })

  export type APImportFileFormType = t.TypeOf<typeof APImportFileFormType>
  export type APImportFileFormRaw = t.OutputOf<typeof APImportFileFormType>

  export const isRightFormatWithDDMMYYYY = (value: string) => {
    const regexFormat = /^\d{2}\d{2}\d{4}$/
    const isValidFormat = regexFormat.test(value)
    return isValidFormat
  }

  export const isRightFormatWithX = (value: string) => {
    const regexFormat = /^\d{1}$/
    const isValidFormat = regexFormat.test(value)
    return isValidFormat
  }

  export const isEqualWithCurrentDate = (value: string) => {
    return value === moment(new Date()).format('DDMMYYYY')
  }

}

export namespace APImportedFilesHistoryForm {
  export const APImportedFilesHistoryC = t.type({
    fromDate: form2.date.optional,
    toDate: form2.date.optional,
    batchName: t.string
  })

  export type APImportedFilesHistoryType = t.TypeOf<typeof APImportedFilesHistoryC>
  export type APImportedFilesHistoryRaw = t.OutputOf<typeof APImportedFilesHistoryC>
}

export namespace APImportedFileDetailHistoryForm {
  export const APImportedFileDetailHistoryC = t.type({
    fromDate: form2.date.optional,
    toDate: form2.date.optional,
    batchName: t.string,
    policyNumber: t.string,
    status: form2.selectOption.optional,
    transactionID: t.string
  })

  export type APImportedFileDetailHistoryType = t.TypeOf<typeof APImportedFileDetailHistoryC>
  export type APImportedFileDetailHistoryRaw = t.OutputOf<typeof APImportedFileDetailHistoryC>
}